import { useSliceContext } from '~/components/Abstracts/SliceManager'

export default function useIsFirstSlice() {
  const { position } = useSliceContext()
  return position === 0 ? true : false
}
